import { render, staticRenderFns } from "./SilenciarProdutosDialog.vue?vue&type=template&id=704f6f8d&scoped=true"
import script from "./SilenciarProdutosDialog.vue?vue&type=script&lang=js"
export * from "./SilenciarProdutosDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704f6f8d",
  null
  
)

export default component.exports